export default function RequestStatusTabs({ items, active, onChange }) {
  return (
    <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto pb-1" role="tablist" aria-label="Filtrér forespørgsler">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={active === item.id}
          onClick={() => onChange(item.id)}
          className={`inline-flex min-h-9 shrink-0 items-center gap-2 rounded-full px-3.5 text-sm font-medium transition-colors ${
            active === item.id
              ? "bg-brand-green text-white shadow-sm"
              : "text-brand-ink hover:bg-brand-soft"
          }`}
          data-testid={`request-status-${item.id}`}
        >
          {item.label}
          <span className={`inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px] ${
            active === item.id ? "bg-white/20 text-white" : "bg-brand-soft text-brand-body"
          }`}>
            {item.count}
          </span>
        </button>
      ))}
    </div>
  );
}

